(function() {
  'use strict';
  
  var TRENDING = ['Gazebos','Pop Up Gazebos','Marquees','Pergolas','Storage Shelters','Greenhouses','Garden Sheds','Tarpaulins'];
  var POPULAR_CATS = [
    {title:'Gazebos',url:'/collections/gazebos',count:'600+'},
    {title:'Marquees',url:'/collections/marquees',count:'100+'},
    {title:'Pergolas',url:'/collections/pergolas',count:'25+'},
    {title:'Storage',url:'/collections/storage-shelters-tents',count:'170+'},
    {title:'Greenhouses',url:'/collections/greenhouses',count:'80+'},
    {title:'Sheds',url:'/collections/garden-sheds',count:'80+'},
  ];

  var debounceTimer;
  var activeIndex = -1;
  var resultsCache = {};

  function init() {
    var wrapper = document.querySelector('.mg-header-search');
    if (!wrapper) return;
    
    var input = wrapper.querySelector('.mg-header-search__input');
    if (!input) return;

    // Create dropdown inside the wrapper (which has position:relative)
    var dropdown = document.createElement('div');
    dropdown.className = 'mg-search-drop';
    dropdown.innerHTML = buildDefault();
    wrapper.appendChild(dropdown);

    // Focus → open
    input.addEventListener('focus', function() {
      dropdown.classList.add('mg-search-drop--open');
      if (!input.value.trim()) dropdown.innerHTML = buildDefault();
    });

    // Typing
    input.addEventListener('input', function() {
      var q = input.value.trim();
      activeIndex = -1;
      if (q.length < 2) {
        dropdown.innerHTML = buildDefault();
        dropdown.classList.add('mg-search-drop--open');
        return;
      }
      dropdown.innerHTML = '<div class="mg-search-loading"><div class="mg-search-spinner"></div>Searching...</div>';
      dropdown.classList.add('mg-search-drop--open');
      
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { doSearch(q, dropdown); }, 250);
    });

    // Keyboard
    input.addEventListener('keydown', function(e) {
      var items = dropdown.querySelectorAll('.mg-search-result, .mg-search-trending-item, .mg-search-cat-card');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        highlightItem(items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, -1);
        highlightItem(items);
      } else if (e.key === 'Enter' && activeIndex >= 0 && items[activeIndex]) {
        e.preventDefault();
        var el = items[activeIndex];
        if (el.href) window.location.href = el.href;
        else if (el.querySelector('a')) window.location.href = el.querySelector('a').href;
      } else if (e.key === 'Escape') {
        dropdown.classList.remove('mg-search-drop--open');
        input.blur();
      }
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (!wrapper.contains(e.target)) {
        dropdown.classList.remove('mg-search-drop--open');
      }
    });

    // Trending clicks
    dropdown.addEventListener('click', function(e) {
      var trending = e.target.closest('.mg-search-trending-item');
      if (trending) {
        e.preventDefault();
        e.stopPropagation();
        input.value = trending.textContent.trim();
        input.dispatchEvent(new Event('input'));
        input.focus();
      }
    });
  }

  function buildDefault() {
    var h = '<div class="mg-search-default">';
    h += '<div class="mg-search-section"><div class="mg-search-section-title">\uD83D\uDD25 Trending Searches</div><div class="mg-search-trending">';
    TRENDING.forEach(function(t) { h += '<a href="#" class="mg-search-trending-item">' + t + '</a>'; });
    h += '</div></div>';
    h += '<div class="mg-search-section"><div class="mg-search-section-title">\uD83D\uDCC2 Popular Categories</div><div class="mg-search-cats">';
    POPULAR_CATS.forEach(function(c) { h += '<a href="' + c.url + '" class="mg-search-cat-card"><span class="mg-search-cat-title">' + c.title + '</span><span class="mg-search-cat-count">' + c.count + ' items</span></a>'; });
    h += '</div></div></div>';
    return h;
  }

  function doSearch(q, dropdown) {
    if (resultsCache[q]) { renderResults(resultsCache[q], q, dropdown); return; }

    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,tag,body')
      .then(function(r) { return r.json(); })
      .then(function(data) { resultsCache[q] = data; renderResults(data, q, dropdown); })
      .catch(function() { dropdown.innerHTML = '<div class="mg-search-empty">Something went wrong. Try again.</div>'; });
  }

  function renderResults(data, q, dropdown) {
    var res = (data.resources || {}).results || {};
    var products = res.products || [];
    var collections = res.collections || [];
    var pages = res.pages || [];
    
    if (!products.length && !collections.length && !pages.length) {
      dropdown.innerHTML = '<div class="mg-search-empty"><div class="mg-search-empty-icon">\uD83D\uDD0D</div><strong>No results for "' + esc(q) + '"</strong><p>Try different keywords or browse our categories</p><div class="mg-search-cats">' + POPULAR_CATS.slice(0,4).map(function(c) { return '<a href="' + c.url + '" class="mg-search-cat-card"><span class="mg-search-cat-title">' + c.title + '</span></a>'; }).join('') + '</div></div>';
      return;
    }

    var h = '<div class="mg-search-results">';

    if (collections.length) {
      h += '<div class="mg-search-section"><div class="mg-search-section-title">\uD83D\uDCC2 Collections</div>';
      collections.forEach(function(c) {
        h += '<a href="' + c.url + '" class="mg-search-result mg-search-result--collection"><div class="mg-search-result-icon">\uD83D\uDCC1</div><div class="mg-search-result-info"><strong>' + hl(c.title, q) + '</strong></div></a>';
      });
      h += '</div>';
    }

    if (products.length) {
      h += '<div class="mg-search-section"><div class="mg-search-section-title">\uD83D\uDED2 Products</div>';
      products.forEach(function(p) {
        var img = p.image ? '<img src="' + p.image.replace(/(\.\w+)(\?|$)/, '_200x200$1$2') + '" alt="" loading="lazy">' : '<div class="mg-search-result-noimg">\uD83D\uDCE6</div>';
        var price = '';
        if (p.price) {
          var pn = (parseFloat(p.price)/100).toFixed(2);
          price = '\u00A3' + pn;
          if (p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price)) {
            var op = (parseFloat(p.compare_at_price_max)/100).toFixed(2);
            price = '<span class="mg-search-old-price">\u00A3' + op + '</span> <span class="mg-search-sale-price">\u00A3' + pn + '</span>';
          }
        }
        var badge = '';
        if (!p.available) badge = '<span class="mg-search-badge mg-search-badge--sold">Sold Out</span>';
        else if (p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price)) badge = '<span class="mg-search-badge mg-search-badge--sale">Sale</span>';
        
        h += '<a href="' + p.url + '" class="mg-search-result mg-search-result--product"><div class="mg-search-result-img">' + img + badge + '</div><div class="mg-search-result-info"><strong>' + hl(p.title, q) + '</strong>';
        if (p.product_type) h += '<span class="mg-search-result-type">' + p.product_type + '</span>';
        h += '</div>';
        if (price) h += '<div class="mg-search-result-price">' + price + '</div>';
        h += '</a>';
      });
      h += '</div>';
    }

    if (pages.length) {
      h += '<div class="mg-search-section"><div class="mg-search-section-title">\uD83D\uDCC4 Pages</div>';
      pages.forEach(function(p) {
        h += '<a href="' + p.url + '" class="mg-search-result mg-search-result--page"><div class="mg-search-result-icon">\uD83D\uDCC4</div><div class="mg-search-result-info"><strong>' + hl(p.title, q) + '</strong></div></a>';
      });
      h += '</div>';
    }

    h += '<a href="/search?q=' + encodeURIComponent(q) + '" class="mg-search-viewall">View all results for "' + esc(q) + '" \u2192</a></div>';
    dropdown.innerHTML = h;
    activeIndex = -1;
  }

  function hl(text, q) {
    if (!q) return text;
    return text.replace(new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi'), '<mark>$1</mark>');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function highlightItem(items) {
    items.forEach(function(el, i) { el.classList.toggle('mg-search-result--active', i === activeIndex); });
    if (activeIndex >= 0 && items[activeIndex]) items[activeIndex].scrollIntoView({ block: 'nearest' });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
